<template>
    <div ref="imguploader" class="uploader">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
            class="mb-2"
        />
        <form ref="imageUploadInput" enctype="multipart/form-data" novalidate>
            <div class="drop-tile" v-if="!disabled">
                <input 
                    type="file" 
                    multiple 
                    :name="uploadFieldName" 
                    :disabled="isSaving" 
                    accept="image/*" 
                    class="input-file" 
                    @change="
                        filesChange($event.target.name, $event.target.files); 
                        fileCount = $event.target.files.length;
                    "
                    @focusout="focusOut()"
                >
                <p class="icon">
                    <i class="fas fa-plus"></i>
                </p>
                <p v-if="isFailed">
                    {{ $t('upload-falhou') }}
                </p>
            </div>
            <!-- Visualização das imagens -->
            <template v-if="showOldPhotos">
                <div 
                    class="img-preview" 
                    v-for="(file, i) in value"
                    :key="file.id"
                >
                    <img 
                        :src="file.caminho" 
                        :alt="file.nome"
                        @click="openGallery(i)"
                        class="clickable"
                    >

                    <b-button  
                        v-if="!disabled"
                        class="button-delete delete-img mb-0"
                        type="is-danger"
                        icon-right="delete"
                        @click="deleteImageActual(i)"
                        v-tippy 
                        :title="$t('deletar')"
                    />
                </div>
            </template>
            <div 
                class="img-preview" 
                v-for="(file, i) in uploadedFiles"
                :key="file.fileName + i"
            >
                <img 
                    :src="file.url" 
                    :alt="file.fileName"
                    @click="openGallery(value.length + i)"
                    class="clickable"
                >

                <b-button  
                    v-if="!disabled"
                    class="button-delete delete-img mb-0"
                    type="is-danger"
                    icon-right="delete"
                    @click="deleteImageNew(i)"
                    v-tippy 
                    :title="$t('deletar')"
                />
            </div>
        </form>
        <h4 class="title" :class="{'invalid': focusedOut && invalid}">
            <span v-if="subtitle != ''"> 
                {{subtitle}} - 
            </span>
            Fotos anexadas: {{imageToGallery.length}}
        </h4>
        <!-- Modal das imagens -->
        <light-box
            ref="galleryImagesUploaded"
            v-if="imageToGallery.length"
            :media="imageToGallery"
            :show-caption="false"
            :show-light-box="false"
        />
    </div>
</template>

<script>
import LightBox from 'vue-image-lightbox';
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
    components: {
        LightBox,
        VerifiedLable,
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        id: {
            default: null
        },
        editable: {
            default: false,
        },
        extensions: {
            type: Array,
            default: () => []
        },
        title:{
            default: 'selecione-uma-ou-mais-imagens'
        },
        subtitle:{
            default: ''
        },
        logourl: {
            default: '',
        },
        qtdeminimafoto: {
            type: Number,
            default: 0
        },
        invalid: {
            type: Boolean,
            default: false
        },
        disableMLtitle: {
            type: Boolean,
            default: false
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required:{ 
            type: Boolean,
            default: false
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null
        },
        tooltipPosition: {
            type: String,
            default: 'is-right'
        },
        tooltipType: {
            type: String,
            default: 'is-dark'
        },
        tooltipMultilined: { 
            type: Boolean,
            default: true
        },
        tooltipSize: {
            type: String,
            default: 'is-large'
        },
        porcentagem: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showOldPhotos: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            fileurl: '',
            uploadError: null,
            currentStatus: null,
            uploadedFiles: [],
            uploadFieldName: 'images',
            imageToGallery: [],
            focusedOut: false,
        };
    },
    computed:{
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        }
    },
    mounted() {
        this.reset();
    },
    created() {
        this.value.forEach(image => {
            this.buildGallery(image.caminho, null)
        });
    },
    methods: {
        reset() {
            // reset form to initial state
            // console.log(this.$refs.imguploader);
            // document.addEventListener('ondragover', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragenter', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragleave', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragend', (e) => this.dragged('dragstart'));
            this.$refs.imageUploadInput.reset();
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
        },
        dragged(styleClass){
            // console.log('worked! dragstarted');
            // e.preventDefault();
            // e.stopPropagation();
            this.$refs.imguploader.classList.add(styleClass);
        },
        draggedEnd(styleClass){
            // console.log('worked! dragended!');
            // e.preventDefault();
            // e.stopPropagation();
            this.$refs.imguploader.classList.remove(styleClass);
        },
        openGallery(index) {
            this.$refs.galleryImagesUploaded.showImage(index)
        },
        buildGallery(image, type){
            this.imageToGallery.push(
                 { // Object For gallery image
                    src: image,
                    thumb: image,
                    type: type
                },
            )
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            this.upload(formData)
                .then(images => {
                    images.forEach(image => {
                        this.uploadedFiles.push(image)
                        this.buildGallery(image.url, image.type)
                    })

                    this.currentStatus = STATUS_SUCCESS;
                    this.$emit('uploadedFiles', this.uploadedFiles);
                })
                .catch(err => {
                    this.uploadError = err.response;
                    this.currentStatus = STATUS_FAILED;
                })
                .finally(_ => {
                    // limpando memória para poder refazer upload da mesma imagem após exclui-la
                    this.$refs.imageUploadInput.reset();
                });
        },
        deleteImageActual(index){ 
            this.$root.confirm({
                message: this.$t('msg-confirma-remover-arquivo-n', { n: this.value[index].nome }),
                onConfirm: (_) => {
                    this.imageToGallery.splice(index, 1);
                    this.$emit('removeActualImage', index);
                },
            });
        },
        deleteImageNew(index){
            this.$root.confirm({
                message: this.$t('msg-confirma-remover-arquivo-n', { n: this.uploadedFiles[index].fileName }),
                onConfirm: (_) => {
                    this.uploadedFiles.splice(index, 1);
                    this.imageToGallery.splice(this.value.length + index, 1);
                    this.$emit('uploadedFiles', this.uploadedFiles);
                },
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                if (fileList[x].type.split('/')[0] == 'image' && fileList[x].size < 2097152 ) {
                    formData.append(fieldName, fileList[x], fileList[x].name);
                }
            });

            // save it 
            if (fileList[0].type.split('/')[0] == 'image' && fileList[0].size < 2097152 ) {
                this.save(formData);
            } else {
                this.$emit('alert', 'error', 'msg-tamanho-excedido');
                console.error(`Imagem recusada. Tamanho: ${fileList[0].size}.`);
                this.currentStatus = STATUS_FAILED;
            }
        },
        upload(formData) {
            const photos = formData.getAll('images');
            const promises = photos.map((x) => this.getImage(x)
                .then(img => ({
                    id: img,
                    type: x.type,
                    originalName: x.name,
                    fileName: x.name,
                    url: img,
                })));
            return Promise.all(promises);
        },
        getImage(file) {
            return new Promise((resolve, reject) => {
                const fReader = new FileReader();
                const img = document.createElement('img');

                fReader.onload = () => {
                    img.src = fReader.result;
                    img.onload = () => {
                        return resolve(img.src)
                    };
                    img.onerror = e => {
                        console.error('Erro ao carregar imagem.', e);
                        this.currentStatus = STATUS_FAILED;
                    }
                }

                fReader.readAsDataURL(file);
            })
        },
        getBase64Image(img) {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            const dataURL = canvas.toDataURL('image/png');

            return dataURL;
        },
        focusOut() {
            this.focusedOut = true;
        },
    }
}

</script>

<style lang="scss" scoped>

.uploader {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    form {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        overflow-x: scroll;
        max-width: 100%;
        height: 100%;
        padding-bottom: 1rem;
    }
    .title {
        font-size: 12px;
        color: $darker-gray-color;
        font-weight: 600;
        margin-bottom: 0;
        text-transform: capitalize;
        padding-bottom: 2px;
    }
    .drop-tile {
        border: 2px solid $primary-color; /* the dash box */
        border-radius: 1rem;
        background: $sovis-white;
        color: $semi-title-color;
        height: 100%;
        width: 10rem;
        min-height: 150px; /* minimum height */
        min-width: 150px;
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 1px 3px 5px 0px rgba(58, 58, 58, 0.7);
        .icon {
            font-size: 2rem;
            color: $primary-color;
        }

        &:hover {
            background: $primary-color-hover;

            p{
                color: $sovis-white;
            }
        }

        p{
            position: relative;
            text-align: center;
            width: 80%;
            font-size: 12px;
            z-index: 0;
        }

    }
    .img-preview {
        position: relative;
        height: 100%;
        width: 10rem;
        min-height: 150px !important; /* minimum height */
        min-width: 150px ;
        margin-left: 1rem;
        //centralizar button delete na imagem
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        
        img{
            width: 100%;
            border-radius: 6px;
            box-shadow: 1px 3px 5px 0px rgba(58, 58, 58, 0.7);
        }

        .button-delete {
            font-size: 1.5rem;
            background: transparent;
            color: $primary-color;
            padding: 0 !important;
            border: none;
        }
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        font-size: 4px !important;
    }

    &.dragstart .drop-tile{
        background: $primary-color-hover;
    }
    .invalid{
        color: $red;
    }
}

</style>

